/*
 * @Author: 曹捷
 * @Date: 2022-02-15 15:01:43
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-03-18 11:05:58
 * @Description: 全局数据
 */

import { OSS_URL } from "./constants/env";
import router from "./router";
import { replaceOrAddDomain } from "./utils";
import { ElMessageBox } from 'element-plus'

export interface AppConfigDto {
  billCircle: boolean;
  billImgs: boolean;
}

class GlobalData {
  constructor() {
  }
  getTokenInfo() {
    let info = localStorage.getItem('user');
    if (info) {
      const data = JSON.parse(info);
      return data?.token;
    }
    return '';
  }
  setToken(token: string) {
    localStorage.setItem('tokenTime', token);
  }
  goto(path: string) {
    router.push(path)
  }
  goBack() {
    router.back();
    // back失败没有返回的时候 跳转首页
  }
  getNewImgUrl(path: string | undefined) {
    if (!path) return ''
    const domain = OSS_URL;
    const newUrl = replaceOrAddDomain(path, domain);
    return newUrl;
  }
  async confirm(title: string, content: string) {

    return ElMessageBox.confirm(content, title, {},)
  }
  // 刷新用户信息
  // async refreshUserInfo() {
  //   store.dispatch('user/refreshUserInfo');
  // }
}
/**
 */
export default new GlobalData();
